import React from "react";
import MobileLiveStatus from "./MobileLiveStatus";
import MobileLotsDetail from "./MobileLotsDetail";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useSelector } from "react-redux";

function MobileSingleLotsAnimation({ singleAuctionData }) {
  const { profile } = useSelector((state) => state?.profileStore);
  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  };
  return (
    <>
      <Swiper
        pagination={pagination}
        modules={[Pagination]}
        className="mySwiper"
      >
        {singleAuctionData?.offers?.map((item, index) => (
          <SwiperSlide key={item.id || index}>
            <div className="flex column" style={{ gap: "3px" }}>
              <MobileLiveStatus item={item} profile={profile} />
              <MobileLotsDetail
                singleAuctionData={singleAuctionData}
                selectedLot={index}
              />
            </div>
          </SwiperSlide>
        ))}
        <p style={{ position: "absolute", bottom: 30 }}>
          Select the Lot number to navigate directly to the Lot.
        </p>
      </Swiper>
    </>
  );
}

export default MobileSingleLotsAnimation;
